let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lprQB")).then(() => parcelRequire('iBhA4'));